export default __webpack_public_path__ + "static/media/person-1.2d37495c.png";